<template>
  <div id="app" :class=" mobile ? $route.name == 'download' ? 'mobile download': 'mobile' : $route.name == 'download' ? 'download ':''">
    <router-view/>
  </div>
</template>
<script>
export default {
    data(){
    return{
      mobile:false
    }
  },
  // computed:
  //   mapState(['lang','local','skin','topShow','leftShow'])
  // ,
  // created(){
  //   require(`../static/skin/${this.skin}/style.less`) 
  // },
  mounted(){
    this.isMobile()
  },
  methods:{
    init(){
      this.isMobile()
    },
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      this.mobile = (flag && flag.length) >0 ? true : false
    },
  }
}
</script>

<style lang="less">

</style>
